export function takeScreenshot(node) {
  const screenshot = (node || document.documentElement).cloneNode(true)
  screenshot.style.pointerEvents = 'none'
  screenshot.style.overflow = 'hidden'
  screenshot.style.webkitUserSelect = 'none'
  screenshot.style.mozUserSelect = 'none'
  screenshot.style.msUserSelect = 'none'
  screenshot.style.oUserSelect = 'none'
  screenshot.style.userSelect = 'none'
  screenshot.dataset.scrollX = window.scrollX
  screenshot.dataset.scrollY = window.scrollY
  const blob = new window.Blob([screenshot.outerHTML], {
    type: 'text/html'
  })
  return blob
}

// FA207 / frank trap — a bare sibling-export call (takeScreenshot) is
// unresolvable once this file's exports are individually frank.toJSON'd for
// platform delivery (project_frank_drops_module_local_helpers; readerVoice.js
// precedent). This is a `this`-bound `function` (uses `this.log`), so the
// fix routes through `this.call(...)` rather than duplicating the helper.
export function generateBlobWindow(node) {
  this.log(this.call('takeScreenshot', node))
  window.URL ||= window.webkitURL
  window.open(window.URL.createObjectURL(this.call('takeScreenshot', node)))
}
